import React from "react";

export type SelectInputProps<T> = {
  options: T[];
  placeholder?: string;
  valueGetter?: (option: T) => any;
  textGetter?: (option: T) => string;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

export function Select<T>(props: SelectInputProps<T>) {
  const {
    options,
    value,
    placeholder,
    valueGetter: _valueGetter,
    textGetter: _textGetter,
    className: _className,
    ...rest
  } = props;
  const defaultGetter = (option: any) => option?.toString();
  const valueGetter = _valueGetter || defaultGetter;
  const textGetter = _textGetter || defaultGetter;
  const dataClassName =
    "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6";
  return (
    <select
      className={`${dataClassName} ${_className} ${
        props.disabled ? "cursor-not-allowed" : ""
      }`}
      value={value}
      {...rest}
    >
      <option value={""}>{!placeholder ? "--Select--" : placeholder}</option>
      {options.map((option, i) => (
        <option key={i} value={valueGetter(option)}>
          {textGetter(option)}
        </option>
      ))}
    </select>
  );
}
